import React, {useCallback, useEffect, useState} from "react";
import ButtonSelect from "../Select/ButtonSelect";
import {ItemSelect} from "../Select/ItemSelect";
import {NumberInput} from "../NumberInput";
import {TextInput} from "../TextInput";
import PropTypes from "prop-types";
import {numberWithCommas, sF, sI} from "../../utilities/NumberFormatter";
import {useMediaQuery} from "react-responsive";
import {axiosInstance} from "../../utilities/AxiosConfig";
import {notify} from "../toast";
import {InputNumber} from "primereact/inputnumber";
import "../Invoice/InvoiceBodyRow.css";


function InvoiceBodyRow(props) {
    const [item, setItem] = useState({id: props.rowItem.itemId, name: props.rowItem.itemName});
    const [qty, setQty] = useState(props.rowItem.quantity || 0);
    const [price, setPrice] = useState(props.rowItem.price || 0.00);
    const [lastPrice, setP] = useState(props.rowItem.lastPrice || 0.00);
    const [stock, setS] = useState(props.rowItem.stock || 0);
    const [total, setTotal] = useState(props.rowItem.total || 0.00);
    const [comment, setComment] = useState(props.rowItem.comment || "");
    const [disableButton, setDisableButton] = useState(false);
    const isDesktop = useMediaQuery({query: '(min-width: 800px)'})

    const updateCurrentRow = useCallback(() => {
        props.setUpdateRow({
            id: props.rowItem.id,
            invoiceId: props.rowItem.invoiceId,
            itemId: item.id,
            itemName: item.name,
            quantity: qty,
            price: price,
            lastPrice: lastPrice,
            stock: stock,
            total: total,
            comment: comment,
        })
    }, [qty, price, lastPrice, stock, total, comment, props, item.id, item.name])
    useEffect(() => {
        updateCurrentRow();
    }, [item.name, qty, price, lastPrice, stock, total, comment])
    useEffect(() => {
        setTotal((parseInt(qty) * parseFloat(price)).toLocaleString())
    }, [qty, price])
    useEffect(() => {
        if (props.rowItem.itemName !== "") {
            props.setLoading(true)
            axiosInstance.get(`inventory/stock/${props.rowItem.itemId}`).then((response) => {
                setS(Number(response.data));
            }).catch(error => {
                notify(error.message, "error")
            }).finally(
                props.setLoading(false)
            )
        }
        if (props.rowItem.itemName !== "") {
            props.setLoading(true)
            axiosInstance.get(`inventory/lastprice/${props.cid}&${props.rowItem.itemId}`).then(response => {
                setP(sF(response.data));
            }).catch(error => {
                setP(0.0);
            }).catch(error => {
                notify(error.message, "error")
            }).finally(
                props.setLoading(false)
            )
        }
    }, [props.rowItem.itemName])

    return (
  <>
    <tr className="invoice-body-row">
      <td className="invoice-body-row__cell text-center">
        <ButtonSelect
          text="+"
          setButton={props.setAddButton}
          variant="primary"
          disable={!props.thisLast || props.isApproved || disableButton}
        />
      </td>

      <td className="invoice-body-row__cell text-start">
        <ItemSelect
          item={item}
          disable={props.isApproved || props.cid === 0}
          itemList={props.itemList}
          setItem={setItem}
          setLoading={props.setLoading}
        />
      </td>

      <td className="invoice-body-row__cell text-end align-content-center">
        <InputNumber
          value={sI(qty)}
          locale="en-IN"
          onFocus={(e) => e.target.select()}
          onValueChange={(e) => setQty(sI(e.target.value))}
          disabled={props.isApproved || item.name === ""}
          max={100000}
          min={0}
          size={11}
          showButtons={true}
          minFractionDigits={0}
          className="invoice-body-row__input h-2rem align-text-right text-right"
        />
      </td>

      {isDesktop && (
        <td className="invoice-body-row__cell text-end align-content-center">
          {stock.toLocaleString()}
        </td>
      )}

      <td className="invoice-body-row__cell text-end align-content-center">
        <InputNumber
          disabled={!props.priceEnable || props.isPosted || item.name === ""}
          onFocus={(e) => e.target.select()}
          value={sF(price)}
          max={10000000}
          onValueChange={(e) => setPrice(sF(e.target.value))}
          minFractionDigits={2}
          size={16}
          className="invoice-body-row__input h-2rem"
        />
      </td>

      {isDesktop && (
        <td className="invoice-body-row__cell text-end align-content-center">
          {numberWithCommas(lastPrice)}
        </td>
      )}

      {isDesktop && (
        <td className="invoice-body-row__cell text-end align-content-center">
          {numberWithCommas(total)}
        </td>
      )}

      {isDesktop && (
        <td className="invoice-body-row__cell text-start align-content-center">
          <TextInput
            value={comment}
            setValue={setComment}
            disable={props.isPosted || item.name === ""}
            placeholder="Comment"
          />
        </td>
      )}

      <td className="invoice-body-row__cell text-center align-content-center">
        <ButtonSelect
          text="-"
          setButton={props.setDeleteButton}
          variant="danger"
          disable={props.isApproved}
        />
      </td>
    </tr>
  </>
    );
}

InvoiceBodyRow.propTypes = {
    rowItem: PropTypes.shape({
        id: PropTypes.string,
        invoiceId: PropTypes.number,
        itemName: PropTypes.string,
        itemId: PropTypes.number,
        quantity: PropTypes.number,
        price: PropTypes.number,
        lastPrice: PropTypes.number,
        stock: PropTypes.number,
        total: PropTypes.any,
        comment: PropTypes.string,
    }).isRequired,
    thisLast: PropTypes.bool.isRequired,
    i: PropTypes.number.isRequired,
    setAddButton: PropTypes.func.isRequired,
    setDeleteButton: PropTypes.func.isRequired,
    priceEnable: PropTypes.bool.isRequired,
    setUpdateRow: PropTypes.func.isRequired,
    isApproved: PropTypes.bool.isRequired,
    isPosted: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
    cid: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    itemList: PropTypes.array.isRequired,


};

export default InvoiceBodyRow;